import { brand } from '@/content/site'
import { Section } from '@/components/ui/Section'
import { SectionHeading } from '@/components/ui/SectionHeading'
import { Reveal } from '@/components/motion/Reveal'
import { Seo } from '@/components/seo/Seo'
import { JsonLd } from '@/components/seo/JsonLd'
import { Hero } from '@/components/sections/Hero'
import { Manifesto } from '@/components/sections/Manifesto'
import { StatsBand } from '@/components/sections/StatsBand'
import { CategoryGrid } from '@/components/sections/CategoryGrid'
// import { StandardsStrip } from '@/components/sections/StandardsStrip' // hidden until standards finalized
import { ProductSpotlight } from '@/components/sections/ProductSpotlight'
import { Craftsmanship } from '@/components/sections/Craftsmanship'
import { WhyChooseUs } from '@/components/sections/WhyChooseUs'
import { Capabilities } from '@/components/sections/Capabilities'
import { IndustriesStrip } from '@/components/sections/IndustriesStrip'
import { ContactCTA } from '@/components/sections/ContactCTA'

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: brand.legalName,
  url: brand.url,
  logo: `${brand.url}${brand.logoBadge}`,
  description: brand.description,
}

export function Home() {
  return (
    <>
      <Seo path="/" />
      <JsonLd data={organizationSchema} />

      {/* 1. Hero — cinematic (protects LCP; motion begins below the fold) */}
      <Hero />

      {/* 2. Editorial manifesto */}
      <Manifesto />

      {/* 3. Credibility stats band */}
      <StatsBand />

      {/* 4. Product categories — asymmetric editorial showcase */}
      <Section>
        <Reveal>
          <SectionHeading
            eyebrow="Our Products"
            title="Explore the range"
            description="Purpose-built protection across welding gloves, driver gloves, welding caps and leather garments."
          />
        </Reveal>
        <Reveal delay={0.05}>
          <CategoryGrid />
        </Reveal>
      </Section>

      {/* 5. Certifications / standards — hidden until finalized; restore when client confirms.
      <Reveal>
        <StandardsStrip />
      </Reveal>
      */}

      {/* 6. Featured products — premium spotlight rail */}
      <ProductSpotlight />

      {/* 7. Materials & craftsmanship — self-animating scroll-pinned sequence.
          NOT wrapped in <Reveal>: its transform would become the containing block
          and break the section's position:sticky pin. */}
      <Craftsmanship />

      {/* 8. Why True Forge */}
      <Reveal>
        <WhyChooseUs />
      </Reveal>

      {/* 9. Capabilities / B2B */}
      <Reveal>
        <Capabilities />
      </Reveal>

      {/* 10. Industries we serve */}
      <Reveal>
        <IndustriesStrip />
      </Reveal>

      {/* 11. Contact CTA */}
      <Reveal>
        <ContactCTA />
      </Reveal>
    </>
  )
}
